import { css } from 'styled-components'

const flexHorizontal = css`
  display: flex;
  flex-direction: row;
`

export default flexHorizontal



// WEBPACK FOOTER //
// ./src/components/styles/mixins/flexHorizontal.js